import { Module } from "./index"
import * as paths from "constants/paths"
import * as modules from "constants/features"
import Administration from "components/UserManagement"

const UserManagementModule: Module = {
	module: modules.USER_MANAGEMENT_MODULE,
	submodules: [
		{
			module: modules.USER_MANAGEMENT_SUBMODULE,
			component: Administration,
			path: paths.USER_MANAGEMENT,
		},
		{
			module: modules.ORGANIZATIONS_MANAGEMENT_SUBMODULE,
			component: Administration,
			path: paths.ORGANIZATIONS_MANAGEMENT,
		},
	],
}

export default UserManagementModule
